import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Star, MessageCircle, Phone } from 'lucide-react';
import { testimonials, contactInfo } from '../data/mock';
import { Link } from 'react-router-dom';

const Temoignages = () => {
  return (
    <div className="min-h-screen bg-black pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-b from-black to-black/95">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            <span className="text-[#cbb26a]">Témoignages</span> clients
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">
            Ce que nos clients disent de leur expérience
          </p>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-16">
            {testimonials.map((testimonial) => (
              <Card key={testimonial.id} className="bg-white/5 border-[#cbb26a]/30 hover:bg-white/10 transition-all duration-300">
                <CardContent className="p-6">
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} size={20} className="fill-[#cbb26a] text-[#cbb26a]" />
                    ))}
                  </div>
                  <p className="text-white/80 mb-6 italic leading-relaxed">
                    "{testimonial.text}"
                  </p>
                  <div className="border-t border-[#cbb26a]/20 pt-4">
                    <p className="text-white font-semibold text-lg">{testimonial.name}</p>
                    <p className="text-white/60">{testimonial.location} • {testimonial.date}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Stats */}
          <div className="max-w-4xl mx-auto mb-16">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Card className="bg-gradient-to-br from-[#cbb26a]/10 to-transparent border-[#cbb26a]/30">
                <CardContent className="p-8 text-center">
                  <div className="text-5xl font-bold text-[#cbb26a] mb-2">100%</div>
                  <div className="text-white/80">Satisfaction client</div>
                </CardContent>
              </Card>
              <Card className="bg-gradient-to-br from-[#cbb26a]/10 to-transparent border-[#cbb26a]/30">
                <CardContent className="p-8 text-center">
                  <div className="text-5xl font-bold text-[#cbb26a] mb-2">5+</div>
                  <div className="text-white/80">Saillies réussies</div>
                </CardContent>
              </Card>
              <Card className="bg-gradient-to-br from-[#cbb26a]/10 to-transparent border-[#cbb26a]/30">
                <CardContent className="p-8 text-center">
                  <div className="flex justify-center mb-2">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={24} className="fill-[#cbb26a] text-[#cbb26a]" />
                    ))}
                  </div>
                  <div className="text-white/80">Note moyenne</div>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center bg-gradient-to-r from-[#cbb26a]/10 to-transparent rounded-xl p-12">
            <h3 className="text-3xl font-bold text-white mb-4">
              Rejoignez nos clients satisfaits
            </h3>
            <p className="text-white/80 mb-8 max-w-2xl mx-auto">
              Faites confiance à notre expérience pour la saillie de votre femelle Labrador
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                asChild
                size="lg"
                className="bg-[#cbb26a] text-black hover:bg-[#d4c485] transition-all duration-300"
              >
                <Link to="/contact">Contactez-nous</Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-[#cbb26a] text-white hover:bg-[#cbb26a]/10 transition-all duration-300"
              >
                <a href={`https://wa.me/33${contactInfo.whatsapp.substring(1)}`} className="flex items-center space-x-2">
                  <MessageCircle size={20} />
                  <span>WhatsApp</span>
                </a>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Temoignages;